var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('ski-round-button',{staticClass:"d-print-none",attrs:{"variant":_vm.variant,"text":"Print siden"},on:{"click":_vm.print}},[_c('print',{staticClass:"svg"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }